import archImg from "../assets/Architecture.jpg";
import indImg from "../assets/IndividualOnboarding.jpg";
import kybImg from "../assets/KYBInboarding.jpg";

const diagrams = [
  {
    id: "arch",
    requires: [],
    title: "Architecture Overview",
    img: archImg,
    alt: "FrankieOne Architecture Overview",
    description:
      "This diagram shows the full FrankieOne platform architecture — how recipes, risk policies, and the workflow engine connect to data providers and check partners. Key components include the API Gateway, Workflow Manager, Risk Decision Engine, Unified Data Model, and the Connection Gateway which routes to IDV, KYC, KYB, AML, and fraud/transaction monitoring providers. Data sources (DVS, Equifax, Experian, Incode, Daon, etc.) can be toggled on or off per configuration.",
  },
  {
    id: "ind",
    requires: ["kyc"],
    title: "Individual Onboarding (KYC Flow)",
    img: indImg,
    alt: "Individual KYC Onboarding Flow",
    description:
      "This diagram shows how your system sends data to FrankieOne via API and processes a user through a workflow. You can have many different workflows configured — a workflow is a series of checks, and you choose which checks to include and in what order. Within each check, one or more data sources can be enabled (e.g. DVS GovID, Equifax, Experian) to increase confidence or match rate — these are toggleable on or off. Each check also produces a risk outcome, which feeds into a configurable risk policy. Finally, the output of the workflow is sent to your system via webhook, where you decide what to do with the entity — pass them, fail them, or run a different workflow (e.g. step up to an enhanced workflow via API).",
  },
  {
    id: "kyb",
    requires: ["kyb"],
    title: "KYB Onboarding (Business + UBO KYC Flow)",
    img: kybImg,
    alt: "KYB Business Onboarding Flow",
    description:
      "This diagram shows the full KYB onboarding flow from your system through FrankieOne's organisation onboarding. Your system sends business details via the API. FrankieOne performs an ABR lookup (returning ABN status, registration date, entity type, location), then a UBO/ASIC search to identify beneficial owners, directors, and shareholders. Company AML screening runs on the organisation. Each identified individual (UBOs, directors) is then sent through FrankieOne's individual workflow/recipe system — running the same checks as shown in the individual onboarding flow above. Results for each entity flow back to your system for a final decision.",
  },
];

export default function IntegrationDiagrams({ checks = {} }: { checks?: Record<string, boolean> }) {
  const visible = diagrams.filter(d =>
    d.requires.length === 0 || d.requires.some(r => checks[r])
  );

  return (
    <div>
      <h2 style={{ color: "#4285fb", borderBottom: "2px solid #4285fb", paddingBottom: 6, marginBottom: 16 }}>
        Integration Diagrams
      </h2>
      <p style={{ fontSize: 12, color: "#444", lineHeight: 1.6, marginBottom: 24 }}>
        These diagrams illustrate the FrankieOne platform architecture and key integration flows.
      </p>

      {visible.map((d) => (
        <div key={d.id} style={{ marginBottom: 36, pageBreakInside: "avoid" }}>
          <h3 style={{ color: "#333", marginBottom: 8 }}>{d.title}</h3>
          <p style={{ fontSize: 12, color: "#444", lineHeight: 1.6, marginBottom: 12 }}>{d.description}</p>
          <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden", background: "white" }}>
            <img src={d.img} alt={d.alt} style={{ width: "100%", display: "block" }} />
          </div>
        </div>
      ))}
    </div>
  );
}
